import { Component, input, output } from "@angular/core";

@Component({
    selector: "sergeant-title",
    templateUrl: "./sergeant-title.component.html",
    styleUrl: "./sergeant-title.component.scss",
})
export class SergeantTitleComponent {
    title = input.required<string>();
    hideShowMore = input<boolean>(false);
    showMoreClicked = output<void>();

    showMore(): void {
        this.showMoreClicked.emit();
    }
}
